import React from "react";
import { ReactComponent as FlexPaymentSvg } from "../../svgs/FlexiblePayment.svg";
import { ReactComponent as HouseServiceSvg } from "../../svgs/houseservice.svg";
import { ReactComponent as ReviewTransactionSvg } from "../../svgs/revtransactions.svg";
import { ReactComponent as Mockup } from "../../svgs/mockup.svg";

function Features() {
  return (
    <section className="pt-12 max-w-[1280px]  mx-auto flex flex-col">
      <div className="flex items-center justify-center px-4 h-[500px] translate-y-[40px] overflow-hidden">
        <Mockup className="h-full" />
      </div>
      <div className="bg-[#F3F5F9] pt-4 px-4 z-[2]">
        <div className="flex flex-col md:flex-row lg:flex-row md:justify-center flex-wrap lg:justify-center mt-16 md:scale-95 lg:scale-[80%]">
          <article className="bg-white rounded-[20px] flex flex-col items-center border border-[#DBE4E9] relative pt-[95px] h-full pr-[50px] pb-[76px] pl-[45px] mb-12 md:mr-4 lg:mr-8">
            <h6 className="font-extrabold text-xl absolute top-5 left-5">01</h6>
            <span>
              <FlexPaymentSvg />
            </span>
            <h3 className="mt-8 text-center font-extrabold text-3xl">
              Flexible payment
            </h3>
            <p className="mt-[51px] textpw-grey text-center lg:w-[280px] text-xl">
              Purchase water from any kind of device.
            </p>
          </article>
          <article className="bg-white rounded-[20px] flex flex-col items-center border border-[#DBE4E9] relative pt-[95px] h-full pr-[50px] pb-[76px] pl-[45px] mb-12 md:mr-4 lg:mr-8">
            <h6 className="font-extrabold text-xl absolute top-5 left-5">02</h6>
            <span>
              <ReviewTransactionSvg />
            </span>
            <h3 className="mt-8 text-center font-extrabold text-3xl lg:w-60">
              Review transactions
            </h3>
            <p className="mt-[17px] textpw-grey text-center lg:w-[280px] text-xl">
              Conveniently access your recent and past transactions anytime.
            </p>
          </article>
          <article className="bg-white rounded-[20px] flex flex-col items-center border border-[#DBE4E9] relative pt-[95px] pr-[50px] pl-[45px] pb-[76px] h-full  mb-12 md:mr-4 lg:mr-8">
            <h6 className="font-extrabold text-xl absolute top-5 left-5">03</h6>
            <span>
              <HouseServiceSvg />
            </span>
            <h3 className="mt-8 text-center font-extrabold text-3xl">
              24 hours service
            </h3>
            <p className="mt-[51px] textpw-grey text-center lg:w-[280px] text-xl">
              Hydronamics staff are always available to swiftly resolve your
              issues 24/7.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}

export default Features;
